module.exports = __webpack_public_path__ + "media/components/helpcenter/InsightsHelp/InsightAlert1-3646bec28dfb17e5b3b1995d5c666740.jpg";